import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { formatRange } from '../../../utils';
import Select from '@material-ui/core/Select';
import { SERVICE_TYPE_FILTERS_EXCLUDING_LEGAL } from '../../../constants/elevation';
import MenuItem from '@material-ui/core/MenuItem';
import DateRangeCustom from '../../Elevation/Components/DateRange';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';

const propTypes = {
    handleClearClick: PropTypes.func.isRequired,
    range: PropTypes.object.isRequired,
    handleCloseClick: PropTypes.func.isRequired,
    showDialog: PropTypes.bool.isRequired,
    serviceType: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.oneOf([null])
    ]).isRequired,
    setRange: PropTypes.func.isRequired,
    setShowDialog: PropTypes.func.isRequired,
    handleServiceTypeChange: PropTypes.func.isRequired,
}

const useStyles = makeStyles(theme => ({
    button: {
        padding: "9px 18.5px",
        width: "100%",
        fontWeight: 400,
        maxWidth: "250px",
        marginRight: theme.spacing(2),
        '& .MuiButton-label': {
            justifyContent: "flex-start",
            textTransform: "none",
            fontSize: "1rem",
            color: theme.palette.primary.main
        },
        [theme.breakpoints.down('sm')]: {
            marginRight: 0,
            marginBottom: theme.spacing(2),
        },
    },
    dialog: {
        '& .MuiDialog-paperWidthSm': {
            width: "auto"
        }
    },
    actions: {
        display: "flex",
        justifyContent: "space-between"
    },
    headerFilters: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    dropdown: {
        maxWidth: "250px",
    },
    loader: {
        width: '30px !important',
        height: '30px !important'
    }
}))

const FiltersSection = ({ handleClearClick, range, handleCloseClick, showDialog, serviceType, setRange, setShowDialog, handleServiceTypeChange, primaryServiceTypeFetched }) => {
    const classes = useStyles()

    return (
        <Box className={classes.headerFilters}>
            <Button
                className={classes.button}
                variant="outlined"
                onClick={() => setShowDialog(true)}
            >
                {range.to && range.from ?
                    formatRange(range).from + " - " + formatRange(range).to
                    :
                    "Filter dashboard by date"
                }
            </Button>
            {!primaryServiceTypeFetched ?
                <CircularProgress color="secondary" className={classes.loader}/>
                :
                <Box>
                    <Select
                        className={classes.dropdown}
                        variant="outlined"
                        option={SERVICE_TYPE_FILTERS_EXCLUDING_LEGAL}
                        value={serviceType ? serviceType : 1}
                        onChange={handleServiceTypeChange}
                    >
                        {SERVICE_TYPE_FILTERS_EXCLUDING_LEGAL.map(serviceType => (
                            <MenuItem
                                key={`service-type-item-${serviceType.type}`}
                                value={serviceType.type}
                            >
                                {serviceType.name}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
            }
            <Dialog
                className={classes.dialog}
                open={showDialog}
                onBackdropClick={handleCloseClick}
            >
                <DialogContent>
                    <DateRangeCustom range={range} setRange={setRange} />
                </DialogContent>
                <DialogActions className={classes.actions}>
                    <Button
                        label="ra.action.cancel"
                        onClick={handleClearClick}
                    >
                        Clear interval
                    </Button>
                    <Button
                        color="secondary"
                        label="ra.action.cancel"
                        onClick={handleCloseClick}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

FiltersSection.propTypes = propTypes

export default FiltersSection